<template>
  <success-page-layout
    web-to-mobile-flag="mupInviteAccepted"
    store-badges-button-code="body-20210304-success-page-join-organisation"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-4">
        {{ $t("headline") }}
      </b-headline>
      <p v-html="$t('copy')" />
    </template>

    <template v-slot:infobox v-if="cancelNoteType">
      <cancel-instructions :cancel-note-type="cancelNoteType" new-subscription-type="mup" />
    </template>

    <template v-slot:image>
      <join-organisation-image />
    </template>
  </success-page-layout>
</template>

<script>
import { getSearchParam } from "@/utils/location"
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import JoinOrganisationImage from "@/pages/success-page/components/join-organisation/image"
import CancelInstructions from "@/pages/success-page/components/shared/cancel-instructions"

export default {
  name: "JoinOrganisationSuccess",
  components: {
    JoinOrganisationImage,
    BHeadline,
    SuccessPageLayout,
    CancelInstructions
  },
  computed: {
    cancelNoteType() {
      return getSearchParam("cancelNote")
    }
  },
  i18n: {
    messages: {
      en: {
        ctaCopy: "Start exploring!",
        headline: "Congrats! Now that you've joined, download the app and start learning.",
        copy: "Now that you're part of your company's subscription, it's time to <strong>download the app for the best experience possible</strong>. Scan the QR code to get started!"
      },
      de: {
        ctaCopy: "Jetzt loslegen!",
        headline: "Willkommen bei Blinkist Premium!",
        copy: "Dein Account als geteiltes Abo ist jetzt aktiv. <br/><br/>Um Blinkist vollständig nutzen zu können, lade die Blinkist App herunter. <br/> <br/> Gehe sicher, dass du dich in der App mit dem gleichen Account einloggst, den du beim Annehmen der Einladung verwendet hast."
      }
    }
  }
}
</script>
